// src/components/StickyCTA.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarCheck, FaPhone, FaWhatsapp, FaTimes, FaArrowUp } from 'react-icons/fa';


const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isNearFooter, setIsNearFooter] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);

    // 👇 Footer detection
    const footer = document.getElementById('footer');

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsNearFooter(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (footer) observer.observe(footer);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (footer) observer.unobserve(footer);
    };
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Main Sticky CTA */}
      <div
  className={`fixed left-1/2 transform -translate-x-1/2 z-40 transition-all duration-300 ${
    isNearFooter ? 'bottom-24' : 'bottom-6'
  }`}
>
        <div className="relative">
          {/* Expanded View */}
          {isExpanded ? (
            <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-4 mb-2 animate-fade-in-up">
              <div className="flex items-center gap-4">
                {/* Book Now Option */}
                <Link
                  to="/contact"
                  className="flex flex-col items-center p-3 rounded-xl hover:bg-[#c9a86c]/10 transition group min-w-[100px]"
                  onClick={() => setIsExpanded(false)}
                >
                  <div className="w-12 h-12 bg-[#c9a86c] rounded-full flex items-center justify-center text-white mb-2 group-hover:scale-110 transition">
                    <FaCalendarCheck size={20} />
                  </div>
                  <span className="text-sm font-medium text-[#1a2b3c]">Book Now</span>
                </Link>

                {/* Check Availability Option */}
                {/* <Link
                  to="/contact"
                  className="flex flex-col items-center p-3 rounded-xl hover:bg-[#c9a86c]/10 transition group min-w-[100px]"
                  onClick={() => setIsExpanded(false)}
                >
                  <div className="w-12 h-12 bg-[#1a2b3c] rounded-full flex items-center justify-center text-white mb-2 group-hover:scale-110 transition">
                    <FaPhone size={20} />
                  </div>
                  <span className="text-sm font-medium text-[#1a2b3c]">Call Us</span>
                </Link> */}

                {/* WhatsApp Option */}
                <button
                  onClick={() => {
                    const url = "https://wa.me/923034935404?text=Hello%20StayIN%2C%20I%20would%20like%20to%20inquire%20about%20apartments";

                    // 👉 WhatsApp open
                    window.open(url, "_blank");

                    // ✅ 👉 GOOGLE CONVERSION TRACKING
                    setTimeout(() => {
                      if (window.gtag) {
                        window.gtag('event', 'conversion', {
                          send_to: 'AW-18044656656/ojOzCO_arZIcEJC4rpxD'
                        });
                      }
                    }, 300);

                    setIsExpanded(false);
                  }}
                  className="flex flex-col items-center p-3 rounded-xl hover:bg-[#c9a86c]/10 transition group min-w-[100px]"
                >
                  <div className="w-12 h-12 bg-[#25D366] rounded-full flex items-center justify-center text-white mb-2 group-hover:scale-110 transition">
                    <FaWhatsapp size={20} />
                  </div>
                  <span className="text-sm font-medium text-[#1a2b3c]">WhatsApp</span>
                </button>

                {/* Close Button */}
                <button
                  onClick={() => setIsExpanded(false)}
                  className="absolute -top-2 -right-2 w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 transition"
                >
                  <FaTimes size={14} className="text-gray-600" />
                </button>
              </div>
            </div>
          ) : (
            /* Collapsed View - Main Button */
            <button
              onClick={() => setIsExpanded(true)}
              className="bg-[#c9a86c] text-white px-8 py-4 rounded-full font-medium hover:bg-[#b38f5a] transition-all duration-300 inline-flex items-center gap-2 justify-center group"
            >
              {/* Pulse Effect */}
              <span className="absolute inset-0 bg-white/20 animate-pulse rounded-full"></span>

              <FaCalendarCheck className="relative z-10" />
              <span className="font-medium text-lg relative z-10">Book Now</span>
              <span className="w-2 h-2 bg-white rounded-full animate-ping absolute right-4"></span>
            </button>
          )}
        </div>
      </div>

      {/* Back to Top Button (Appears with CTA) */}
      <button
        onClick={scrollToTop}
        className={`fixed right-6 z-50 bg-[#c9a86c] text-white w-14 h-14 rounded-full font-medium hover:bg-[#b38f5a] transition text-md gap-2 flex items-center justify-center group animate-bounce-slow ${isNearFooter ? 'bottom-[193px]' : 'bottom-[87px]'}`}
        aria-label="Back to top"
        
      >
        <FaArrowUp className="group-hover:-translate-y-1 transition-transform" />
      </button>
    </>
  );
};

export default StickyCTA;